import { normalizeRoleSlug } from "../../../public/utils/roleAccess";

export function isOfficeRoleSlug(roleSlug) {
  return normalizeRoleSlug(roleSlug) === "office";
}
